export * from './linescape-ceo-to-speak-at-global-liner-shipping-conference';


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-ceo-to-speak-at-global-liner-shipping-conference/index.ts